import styled, { css } from '../../config/theme'

const topRight = css`
  left: 0;
  bottom: calc(100% + 10px);

  &:before {
    left: 11px;
    bottom: -6px;
    border-right: 1px solid #E0E0E0;
    border-bottom: 1px solid #E0E0E0;
  }
`

const bottomLeft = css`
  right: 0;
  top: calc(100% + 10px);

  &:before {
    right: 11px;
    top: -6px;
    border-left: 1px solid #E0E0E0;
    border-top: 1px solid #E0E0E0;
  }
`

const mapPositionToCss = {
  'bottom-left': bottomLeft,
  'top-right': topRight,
}

const Container = styled.div`
  position: relative;
`

const Content = styled.div<{ open: boolean, position: keyof typeof mapPositionToCss }>`
  display: ${props => props.open ? 'flex' : 'none'};

  position: absolute;
  z-index: ${props => props.theme.zIndex.backdropContent};

  ${props => mapPositionToCss[props.position]}

  flex-direction: column;

  width: 250px;
  padding: 10px;
  border-radius: 5px;
  background: white;
  border: 1px solid ${props => props.theme.color.lightGray};

  > *:not(:last-child) {
    margin-bottom: 5px;
  }

  &:before {
    background: white;
    position: absolute;
    height: 10px;
    width: 10px;
    content: '';
    transform: rotate(45deg);
  }
`

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);

  z-index: ${props => props.theme.zIndex.backdrop};
`

export {
  Container,
  Content,
  Backdrop,
}
